<script setup lang="ts">
import { useSlots } from "vue";
import { useStore } from "vuex";

import { PageContent, Toast } from "@lde/core_lde_vue";

import CommunicationsList from "@/components/communications/CommunicationsList.ts.vue";

const slots = useSlots();

const store = useStore();
const isLogged = store.getters?.isLogged;
const isCataloguePublicActif = store.getters?.isCataloguePublicActif;
const showTestBanner = import.meta.env.VUE_APP_SHOW_TEST_BANNER === "true";
</script>

<template>
  <PageContent>
    <!-- Passe tous les slots dynamiquement -->
    <template
      v-for="(_, name) in slots"
      :key="name"
      #[name]
    >
      <!-- Injection avant le slot content -->
      <CommunicationsList
        v-if="name === 'content' && $store.getters?.isLogged"
      />
      <Toast
        v-else-if="name === 'content' && !isLogged && isCataloguePublicActif && showTestBanner"
        id="temp_banner_test"
        variant="warning"
        :title="$t('catalogue-public.env-test-titre')"
        :content="$t('catalogue-public.env-test-contenu')"
        show-icon
        hide-close-btn
      />
      <slot :name="name" />
    </template>
  </PageContent>
</template>

<style lang="scss" scoped>
#temp_banner_test {
  margin-bottom: 1rem;
}
</style>
